import { render, staticRenderFns } from "./DetalhesConfMeta.vue?vue&type=template&id=0037838f&"
import script from "./DetalhesConfMeta.vue?vue&type=script&lang=js&"
export * from "./DetalhesConfMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/DetalhesConfMeta.vue
// module id = 1226
// module chunks = 28